import React from "react";

export const LegalLayout = ({
    kicker,
    title,
    updated,
    children,
    testId,
}) => (
    <main
        data-testid={testId}
        className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-24 md:pb-32"
    >
        <span className="brr-overline">{kicker}</span>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-5 mb-4">
            {title}
        </h1>
        {updated ? (
            <p className="text-xs tracking-[0.18em] uppercase opacity-60 mb-12">
                {updated}
            </p>
        ) : null}
        <article className="legal-prose">{children}</article>
        <style>{`
            .legal-prose p {
                font-size: 16px;
                line-height: 1.85;
                color: var(--brr-ink-2);
                font-weight: 300;
                margin: 0 0 1.25rem 0;
            }
            .legal-prose h2 {
                font-family: 'Playfair Display', serif;
                font-size: 1.5rem;
                line-height: 1.25;
                color: var(--brr-ink);
                margin: 2.5rem 0 1rem 0;
                font-weight: 500;
            }
            .legal-prose a {
                color: var(--brr-blue-hover);
                text-decoration: underline;
                text-underline-offset: 3px;
            }
            .legal-prose ul {
                padding-left: 1.25rem;
                margin: 0 0 1.25rem 0;
                color: var(--brr-ink-2);
                font-weight: 300;
                line-height: 1.85;
            }
            .legal-prose li { margin-bottom: 0.5rem; }
        `}</style>
    </main>
);
